import { useCallback } from "react";
import type { AuthUser, Membership } from "../types";
import { userHasPermission } from "./authContextTypes";

interface AuthPermissionOptions {
  canManageOrganizations: boolean;
  memberships: Membership[];
  user: AuthUser | null;
}

/** Builds stable permission checks for the authentication context. */
export function useAuthPermissions({
  canManageOrganizations,
  memberships,
  user,
}: AuthPermissionOptions) {
  const hasPermission = useCallback(
    (permission: string) => userHasPermission(user, canManageOrganizations, permission),
    [canManageOrganizations, user],
  );

  const hasOrgAccess = useCallback(
    (orgName: string) => {
      if (!user) return false;
      if (user.isAdmin) return true;
      return memberships.some((membership) => membership.organizationName === orgName);
    },
    [memberships, user],
  );

  return { hasOrgAccess, hasPermission };
}
